$(".custom-pdp-video-link").click(function(){
  $(this).parents(".custom-pdp-video-swiper").find("custom-pdp-video-link").removeClass("active");
  $(this).parents(".custom-pdp-video-swiper").find(".custom-pdp-video").trigger("pause");
  $(this).parents(".custom-pdp-video-swiper").find(".custom-pdp-slide-play-btn").addClass("active");
  $(this).parents(".custom-pdp-video-swiper").find(".custom-pdp-slide-stop-btn").removeClass("active");
  if($(this).hasClass("active")){
    $(this).find(".custom-pdp-video").trigger("pause");
    $(this).removeClass("active");
    $(this).find(".custom-pdp-slide-play-btn").addClass("active");
    $(this).find(".custom-pdp-slide-stop-btn").removeClass("active");
  }
  else{
    $(this).find(".custom-pdp-video").trigger("play");
    $(this).addClass("active");
    $(this).find(".custom-pdp-slide-play-btn").removeClass("active");
    $(this).find(".custom-pdp-slide-stop-btn").addClass("active");
  }
})

$(".custom-plp-item").click(function(){
  let id = $(this).attr("data-id");
  if($(`.custom-plp-wrapper[data-id="${id}"]`).length > 0){
    $(".custom-plp-item").removeClass("active");
    $(this).addClass("active");
    $(".custom-plp-wrapper").removeClass("active");
    $(`.custom-plp-wrapper[data-id="${id}"]`).addClass("active");
  }
})

if($(".custom-main-product-container .product-form__buttons").length > 0){
  var btn = $(".custom-main-product-container .product-form").offset().top + $(".custom-main-product-container .product-form").outerHeight();
  $(window).resize(function(){
    btn = $(".custom-main-product-container .product-form").offset().top + $(".custom-main-product-container .product-form").outerHeight();
  })
  let wrapper = $(".custom-sticky-atc-main-wrapper");
  $(document).scroll(function() {
    var y = $(this).scrollTop();
    if (y > btn){
      wrapper.addClass("custom-sticky-active");
    } else {
      wrapper.removeClass("custom-sticky-active");
    }
  });
}

$(".custom-sticky-atc-btn").click(function(){
  $(".custom-buy-buttons-wrapper .product-form__submit").trigger("click");
})

$(".custom-main-product-media-see-in-action").click(function(){
  let ind = $(this).parents(".custom-main-product-media-top-wrap").find(".custom-main-product-media-video").eq(0).parent().attr("aria-label").split("/")[0].trim();
  let index = parseInt(ind) - 1;
  $(this).parents(".custom-main-product-media-top-wrap").find(".custom-main-product-media-swiper")[0].swiper.slideTo(index);
})

$(".custom-video-slider-play-btn").click(function(){
  $(this).parents(".custom-video-slider-slide-content").find(".custom-video-slider-video").trigger("play");
  $(this).removeClass("active");
  $(this).next(".custom-video-slider-stop-btn").addClass("active");
})
$(".custom-video-slider-stop-btn").click(function(){
  $(this).parents(".custom-video-slider-slide-content").find(".custom-video-slider-video").trigger("pause");
  $(this).removeClass("active");
  $(this).prev(".custom-video-slider-play-btn").addClass("active");
})
$(".custom-video-slider-mute-btn").click(function(){
  $(this).parents(".custom-video-slider-slide-content").find(".custom-video-slider-video")[0].muted = true;
  $(this).hide();
  $(this).next(".custom-video-slider-unmute-btn").show();
})
$(".custom-video-slider-unmute-btn").click(function(){
  $(this).parents(".custom-video-slider-slide-content").find(".custom-video-slider-video")[0].muted = false;
  $(this).hide();
  $(this).prev(".custom-video-slider-mute-btn").show();
})

$(".custom-experts-play-btn").click(function(){
  $(this).parent().find(".custom-expets-video").trigger("play");
  $(this).removeClass("active");
  $(this).next(".custom-experts-stop-btn").addClass("active");
})
$(".custom-experts-stop-btn").click(function(){
  $(this).parent().find(".custom-expets-video").trigger("pause");
  $(this).removeClass("active");
  $(this).prev(".custom-experts-play-btn").addClass("active");
})
$(".custom-experts-mute-btn").click(function(){
  $(this).parent().find(".custom-expets-video")[0].muted = true;
  $(this).hide();
  $(this).next(".custom-experts-unmute-btn").show();
})
$(".custom-experts-unmute-btn").click(function(){
  $(this).parent().find(".custom-expets-video")[0].muted = false;
  $(this).hide();
  $(this).prev(".custom-experts-mute-btn").show();
})

$(".custom-experts-images-item").click(function(){
  $(this).parent().find(".custom-experts-images-item").removeClass("active");
  $(this).addClass("active");
  let ind = $(this).attr("data-index");
  $(this).parents(".custom-experts-wrapper").find(`.custom-experts-vidoes`).removeClass("active");
  $(this).parents(".custom-experts-wrapper").find(`.custom-experts-info-item`).removeClass("active");
  $(this).parents(".custom-experts-wrapper").find(`.custom-experts-vidoes[data-index="${ind}"]`).addClass("active");
  $(this).parents(".custom-experts-wrapper").find(`.custom-experts-vidoes`).find(".custom-experts-stop-btn").trigger("click");
  $(this).parents(".custom-experts-wrapper").find(`.custom-experts-vidoes[data-index="${ind}"]`).find(".custom-experts-play-btn").trigger("click");
  $(this).parents(".custom-experts-wrapper").find(`.custom-experts-info-item[data-index="${ind}"]`).addClass("active");
})

$(".custom-video-slider-slide-content").hover(function(){
  $(this).find(".custom-video-slider-play-btn").trigger("click");
}, function(){
  $(this).find(".custom-video-slider-stop-btn").trigger("click");
})

$(".custom-ba-list-item").click(function(){
  let title = $(this).attr("data-title");
  $(this).parent().find(".custom-ba-list-item").removeClass("active");
  $(this).addClass("active");
  $(this).parents(".custom-ba").find(`.custom-ba-content`).hide();
  $(this).parents(".custom-ba").find(`.custom-ba-content[data-title="${title}"]`).slideDown(300);
})

$(".custom-faq-block-title").click(function(){
    if($(this).parent().hasClass("active")){
        $(this).parent().toggleClass("active");
        $(this).next(".custom-faq-block-content").slideToggle(250);
    }
    else{
        $(this).parents(".custom-faq-block-wrapper").find(".custom-faq-block").removeClass("active");
        $(this).parents(".custom-faq-block-wrapper").find(".custom-faq-block-content").slideUp(250);
        $(this).parent().addClass("active");
        $(this).next(".custom-faq-block-content").slideDown(250);
    }
})

$(".custom-acc-title-wrapper").click(function(){
  if($(this).hasClass("active")){
      $(this).toggleClass("active");
      $(this).next(".custom-acc-content").slideToggle(250);
  }
  else{
      $(this).parents(".custom-acc-wrapper").find(".custom-acc-title-wrapper").removeClass("active");
      $(this).parents(".custom-acc-wrapper").find(".custom-acc-content").slideUp(250);
      $(this).addClass("active");
      $(this).next(".custom-acc-content").slideDown(250);
  }
})

$(".footer-block__heading").click(function(){
    if($(this).hasClass("active")){
        $(this).toggleClass("active");
        $(this).next(".footer-block__details-content").slideToggle(250);
    }
    else{
        $(this).parents(".footer__blocks-wrapper").find(".footer-block__heading").removeClass("active");
        $(this).parents(".footer__blocks-wrapper").find(".footer-block__details-content").slideUp(250);
        $(this).addClass("active");
        $(this).next(".footer-block__details-content").slideDown(250);
    }
});

$(document).on("click", ".custom-cart-upsell-atc", function(){
    let arr = [];
    arr.push({ 'id': $(this).attr("data-id"), 'quantity': 1 });
    AddUpsellToCart(arr, $(this));
})

$(".custom-hotspots-item").click(function(){
  $(this).parent().find(".custom-hotspots-item").removeClass("active");
  $(this).addClass("active");
  $(this).parents(".custom-hotspots").find(".custom-hotspots-mobile-text").text($(this).find(".custom-hotspots-text").text());
})

$(document).on("click", ".custom-addon-atc", function(){
  let arr = [];
  arr.push({ 'id': $(this).attr("data-id"), 'quantity': 1 });
  AddUpsellToCart(arr, $(this), true);
})

function AddUpsellToCart(productsArr, $this, open=false){
    $this.addClass("active");
    let formData = {
      'items': productsArr,
      sections: "cart-drawer,cart-icon-bubble"
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .then(res => {
      if(res.status){
        console.log(res);
      }
      else{
        const cartParsedData = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
        const cartBubbleParsedData = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
        $("cart-drawer.drawer").removeClass("is-empty");
        $(".drawer__inner").html($(cartParsedData).find(".drawer__inner").html());
        $("#cart-icon-bubble").html($(cartBubbleParsedData).find(".shopify-section").html());
        if(open){
          document.querySelector("#cart-icon-bubble").dispatchEvent(new Event('click'));
          $(".cart-count-bubble").trigger("click");
        }
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(() => {
      $this.removeClass("active");
    });
  }

  $(document).on("click", ".custom-header-drawer-close", function(){
    $(".header__icon--menu").trigger("click");
  })
  
  Fancybox.bind("[data-fancybox]", {});

  $(".custom-main-product-swatch").hover(function(){
    $(".custom-product-swatch-heading span").text($(this).attr("data-title"));
  }, function(){
    $(".custom-product-swatch-heading span").text($(this).attr("data-d-title"));
  })